// @flow
import React, { useCallback } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import MenuButton from "root/components/MenuButton/MenuButton";
import t from "common/i18n";
import bindActions, { types as ats } from "../../actions";
import SVG_ICONS from "~/assets/icons/icons";

type OwnProps = {|
    className?: string,
    onClick?: () => void,
|};

type Props = {
    ...OwnProps,
    [string]: Function
};

export const CloseButton = (props: Props) => {
	const closeAction = props[ats.DO_CLOSE_WIDGET];
	const customClose = props.onClick;

	const onClick = useCallback(() => (customClose ? customClose() : closeAction()),
		[closeAction, customClose]);

	return <div className={cx("CloseButton", props.className)}>
		<MenuButton dataTest="close-dialog-icon"
					icon={SVG_ICONS.CLOSE}
					tabIndex={0}
					ariaLabel={t("aria_label.close")}
			onClick={onClick}/>
	</div>;
};

export default connect<Props, OwnProps, _, _, _, _>(
	null,
	bindActions,
)(CloseButton);
